import Vue from 'vue'
import Cookie from 'vue-cookie'
import axios from 'axios'
import App from './App.vue'
import router from './router'



Vue.config.productionTip = false
Vue.prototype.$axios = axios
Vue.use(Cookie)

new Vue({
    router,
    render: h => h(App)
}).$mount('#app')
